export { default } from './MarketDetails'
